import {
  Button,
  Card,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  Stack,
} from '@mui/material';
import { get } from 'lodash';
import { ChangeEvent, ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from 'src/components/icons';
import { DEFAULT_PAGE, DEFAULT_PAGE_ITEMS } from '../../../constants/base';
import useStyles from './styles';

interface DataTableFooterProps {
  category?: 'applications' | 'users' | 'questions' | undefined;
  total: number;
  query: Record<string, any>;
  onUpdate: (x: Record<string, any>) => void;
}
export const DataTableFooter: ComponentType<DataTableFooterProps> = ({
  category,
  total,
  query,
  onUpdate,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const page = parseInt(get(query, 'page', DEFAULT_PAGE));
  const pageItems = get(query, 'pageItems', DEFAULT_PAGE_ITEMS);
  const totalPages = Math.ceil(total / parseInt(pageItems));

  const handleChangePage = (event: ChangeEvent<unknown>, value: number) => {
    onUpdate({ ...query, page: value });
  };

  const handleChangePageItems = (event: SelectChangeEvent) => {
    onUpdate({ ...query, pageItems: event.target.value, page: 1 });
  };

  return (
    <Card
      component={Stack}
      className={classes.root}
      direction="row"
      justifyContent="space-between"
      spacing={2}
    >
      {/* select page count */}
      <Stack direction="row" alignItems="center">
        {t('showedOnPage', 'На странице')}
        <Select
          sx={{ width: 54 }}
          size="small"
          value={pageItems}
          onChange={handleChangePageItems}
          IconComponent={Icons.SolidDropdown}
          variant="filled"
          classes={{
            root: classes.selectRoot,
            select: classes.select,
            icon: classes.selectIcon,
          }}
          disabled={total <= 8}
        >
          <MenuItem value="8">8</MenuItem>
          <MenuItem value="16">16</MenuItem>
          <MenuItem value="24">24</MenuItem>
        </Select>
        / {total} {category && t(`dataTable.category[${category}]`)}
      </Stack>

      {/* pagination */}
      <Stack direction="row" alignItems="center">
        <Button
          size="small"
          startIcon={<Icons.DoubleChevronLeft />}
          disabled={page === 1}
          onClick={() => onUpdate({ ...query, page: 1 })}
        >
          {t('toStart', 'В начало')}
        </Button>

        <Pagination count={totalPages} page={page} onChange={handleChangePage} />

        <Button
          size="small"
          endIcon={<Icons.DoubleChevronRight />}
          disabled={page === totalPages}
          onClick={() => onUpdate({ ...query, page: totalPages })}
        >
          {t('toEnd', 'В конец')}
        </Button>
      </Stack>
    </Card>
  );
};
